import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type DiffRow = {
  sheetId: string;
  rowIndex: number;
  isOutOfSync?: boolean;
  data: Record<string, any>;
};

type DiffState = {
  rows: Record<string, DiffRow>;
};

const initialState: DiffState = {
  rows: {},
};

function buildDiffKey(sheetId: string, rowIndex: number) {
  return `${sheetId}:${rowIndex}`;
}

const diffSlice = createSlice({
  name: "diffs",
  initialState,
  reducers: {
    upsertDiffRow(state, action: PayloadAction<DiffRow>) {
      const key = buildDiffKey(action.payload.sheetId, action.payload.rowIndex);
      state.rows[key] = {
        ...action.payload,
        isOutOfSync: action?.payload?.isOutOfSync === true ? true : false,
      };
    },
    removeDiffRow(state, action: PayloadAction<{ sheetId: string; rowIndex: number }>) {
      const key = buildDiffKey(action.payload.sheetId, action.payload.rowIndex);
      delete state.rows[key];
    },
    clearSheetDiffs(state, action: PayloadAction<string>) {
      const sheetId = action.payload;
      Object.keys(state.rows).forEach((key) => {
        if (key.startsWith(`${sheetId}:`)) {
          delete state.rows[key];
        }
      });
    },
    clearDiffs(state) {
      state.rows = {};
    },
  },
});

export const { upsertDiffRow, removeDiffRow, clearSheetDiffs, clearDiffs } = diffSlice.actions;
export default diffSlice.reducer;
